import { isVivaEngageCopilotMVPEnabled } from '@ms/yammer-data/dist/domains/copilot/selectors';

import { useSelector } from '../useSelector';

export const useIsVivaEngageCopilotMVPEnabled = () => useSelector(isVivaEngageCopilotMVPEnabled);
